import { useMemo } from "react";
import { useLocation } from "react-router-dom";

import {
  useGetL1NavBarColorVariants,
  useJobPagePath,
} from "@js/apps/common/hooks";
import { useIsNodeStaff } from "@js/apps/common/hooks/is-node-staff";
import { useFreelancerMyWorkMainPath } from "@js/apps/freelancer/hooks/use-freelancer-my-work-main-path";
import {
  findCurrentNavItem,
  getNavMenuColorVariant,
} from "@js/layouts/app/utils/common-navigation";
import { getFreelancerNavMenuItems } from "@js/layouts/app/utils/freelancer-navigation";

export const useFreelancerSidebar = () => {
  const { pathname } = useLocation();
  const { jobsPath } = useJobPagePath();
  const { myWorkMainPath } = useFreelancerMyWorkMainPath();
  const isNodeStaff = useIsNodeStaff();
  const L1ColorVariant = useGetL1NavBarColorVariants(pathname);

  const FREELANCER_ITEMS = useMemo(
    () => getFreelancerNavMenuItems({ jobsPath, myWorkMainPath, isNodeStaff }),
    [jobsPath, myWorkMainPath, isNodeStaff],
  );

  const freelancerSidebarItems = useMemo(() => {
    return FREELANCER_ITEMS.filter((item) => item.canAccess);
  }, [FREELANCER_ITEMS]);

  const currentLinkVariant = useMemo(() => {
    const currentLinkItem = findCurrentNavItem({
      items: FREELANCER_ITEMS,
      exact: true,
      pathname,
    });
    return getNavMenuColorVariant(currentLinkItem, pathname);
  }, [pathname, FREELANCER_ITEMS]);

  return {
    sidebarItems: freelancerSidebarItems,
    itemVariant: L1ColorVariant || currentLinkVariant,
  };
};
